import { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { Badge, statusVariant } from "../components/Badge";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Popular() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/popular");
    setRows(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const remove = async (row) => {
    if (!window.confirm(`Delete ${row.title}?`)) return;
    await api.delete(`/popular/${row.id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="popular-page">
      <PageHeader title="Popular List" subtitle="Featured promotions and homepage highlights" />
      {loading ? (
        <div className="bg-white border border-gray-200 rounded-sm p-10 text-center text-sm text-gray-500">Loading...</div>
      ) : rows.length === 0 ? (
        <div className="bg-white border border-gray-200 rounded-sm p-10 text-center text-sm text-gray-500">No popular items yet.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="popular-grid">
          {rows.map((r) => (
            <div key={r.id} className="bg-white border border-gray-200 rounded-sm overflow-hidden" data-testid={`popular-card-${r.id}`}>
              {r.image ? (
                <img src={r.image} alt={r.title} className="w-full h-40 object-cover" />
              ) : (
                <div className="w-full h-40 bg-gray-100" />
              )}
              <div className="p-4">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <div className="font-display font-bold text-gray-900">{r.title}</div>
                    <div className="text-xs text-gray-500 mt-1 line-clamp-2">{r.description}</div>
                  </div>
                  <Badge variant={statusVariant(r.status)}>{r.status}</Badge>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-[11px] uppercase tracking-wider text-gray-500">Order · {r.order}</span>
                  <button onClick={() => remove(r)} className="h-8 w-8 inline-flex items-center justify-center border border-gray-200 rounded-sm text-gray-500 hover:text-red-600 hover:border-red-200" data-testid={`popular-delete-${r.id}`}>
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
